// extracted by mini-css-extract-plugin
export var addButton = "_nv-0";
export var border = "_nv-8";
export var check = "_nv-h";
export var danger = "_nv-6";
export var dropdownContainer = "_nv-1";
export var editModalBody = "_nv-j";
export var footerContainer = "_nv-i";
export var fullWidth = "_nv-a";
export var hide = "_nv-9";
export var icon = "_nv-3";
export var input = "_nv-7";
export var inputFlex = "_nv-b";
export var inputWrapper = "_nv-c";
export var manualFocus = "_nv-5";
export var optionButton = "_nv-4";
export var pillWrapper = "_nv-e";
export var pointer = "_nv-2";
export var showOverflow = "_nv-f";
export var tagsFlex = "_nv-d";
export var xButton = "_nv-g";